module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "mt4"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.labels.primaryEmail))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryEmail),
      expression: "primaryEmail"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.primaryEmail)
    },
    on: {
      "blur": function($event) {
        return _vm.setEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailValidationMessages.help) ? _c('div', {
    staticClass: "f6 silver mt2"
  }, [_vm._v(_vm._s(_vm.emailValidationMessages.help))]) : _vm._e(), _vm._v(" "), (_vm.emailValidationMessages.error) ? _c('div', {
    staticClass: "red f7 mt2"
  }, [_vm._v(_vm._s(_vm.emailValidationMessages.error))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01ed9596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment-methods/shared/components/EmailForm.vue
// module id = 1219
// module chunks = 0